/**
 * Здесь описаны значения клиентских брекпоинтов, которые применяются
 * в зависимости от ширины экрана.
 */
const MOBILE_SMALL = 'mobile-small';
const MOBILE_BIG = 'mobile-big';
const DESKTOP_SMALL = 'desktop-small';
const DESKTOP_BIG = 'desktop-big';

const viewportBreakpoints = {};
viewportBreakpoints[MOBILE_SMALL] = '375px';
viewportBreakpoints[MOBILE_BIG] = '750px';
viewportBreakpoints[DESKTOP_SMALL] = '1024px';
viewportBreakpoints[DESKTOP_BIG] = '1280px';

/**
 * CommonJS экспорт тут необходим для прокидывания брейкпоинтов в precss чтоб
 * они были потом доступны в css.
 */
module.exports = {
  MOBILE_SMALL,
  MOBILE_BIG,
  DESKTOP_SMALL,
  DESKTOP_BIG,
  viewportBreakpoints,
};
